import { Calculator, Calendar, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import Beregner from '../../components/Beregner';
import SEO from '../../components/SEO';

export default function BeregnerPageEn() {
  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Savings Calculator - Calculate Your Return with Danshaker"
        description="Use our interactive savings calculator to see how much time and money you can save in your stable facility with a Danshaker sorting machine."
        path="/en/calculator"
        lang="en"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Main Content */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-24 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Calculator className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Optimize your stable budget</span>
          </div>
          <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Savings Calculator
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed font-medium">
            Calculate your potential annual savings and see how quickly the Danshaker pays for itself based on your daily bedding consumption and stable hours.
          </p>
        </div>

        <Beregner lang="en" />

        {/* Support Section */}
        <div className="mt-16 text-center border-t border-slate-200 pt-12">
          <h2 className="text-xl font-bold text-slate-900 mb-2">Want help reviewing your numbers?</h2>
          <p className="text-slate-600 max-w-xl mx-auto mb-6 text-sm">
            Contact Rasmus for an honest, no-obligation conversation about the savings potential in your specific facility.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:25303589"
              className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-6 py-3 font-bold text-white transition hover:bg-slate-800"
            >
              <Phone className="h-4 w-4 text-[#0E67A2]" />
              Call +45 2530 3589
            </a>
            <Link
              to="/en/free-demo"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-6 py-3 font-bold text-white transition hover:bg-[#0E67A2]/90"
            >
              <Calendar className="h-4 w-4" />
              Book free on-site demo
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
